import type { Color } from '@onefootprint/design-tokens';

const colorToCssVar: Record<Color, string> = {
  primary: '--text-color-primary',
  secondary: '--text-color-secondary',
  tertiary: '--text-color-tertiary',
  quaternary: '--text-color-quaternary',
  quinary: '--text-color-quinary',
  senary: '--text-color-senary',
  septenary: '--text-color-septenary',
  accent: '--text-color-accent',
  error: '--text-color-error',
  success: '--text-color-success',
  warning: '--text-color-warning',
  info: '--text-color-info',
  neutral: '--text-color-neutral',
  successInverted: '--text-color-success-inverted',
  warningInverted: '--text-color-warning-inverted',
  errorInverted: '--text-color-error-inverted',
  infoInverted: '--text-color-info-inverted',
  neutralInverted: '--text-color-neutral-inverted',
};

export const getIconColor = (color?: Color | string): string => {
  if (!color) return 'currentColor';

  const cssVar = colorToCssVar[color as Color];
  if (cssVar) return `var(${cssVar})`;

  return color;
};
